import { useMutation, useQueryClient } from "@tanstack/react-query";

import { completeDocumentUpload } from "@/adapters/api";
import { toDocument } from "../utils/map.ts";
import { documentsQueryKey } from "./use-documents.ts";

export function useCompleteUpload(constructionId: string | undefined) {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (documentId: string) => {
			if (!constructionId) throw new Error("missing construction");
			return toDocument(
				await completeDocumentUpload(constructionId, documentId),
			);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: documentsQueryKey(constructionId),
			});
		},
	});
}
